module.exports = "static/assets/9c604018c786598c0f198af5e798cd16.png";